import OnlineAppComponent from "../lib/online_app_component";
import verge from "verge";

const AuxContentConfig = {
    baseHtmlClass: 'online_app__aux__content'
}

export class AuxContent extends OnlineAppComponent {

    static createElement() {
        let element = document.createElement('div');
        const htmlClass = `${ AuxContentConfig.baseHtmlClass }`;
        element.setAttribute("class", htmlClass);
        return element;
    }

    constructor(onlineAppAux) {
        super(null, onlineAppAux.onlineApp, AuxContentConfig);
        this.onlineAppAux = onlineAppAux;
        this.title = null;
        this.url = null;
        this.content = null;
        this.element = AuxContent.createElement();

        this.scrollTimeout = null;
        // this.onlineApp.env.addEventListener('scroll', this.scrollThrottler.bind(this));
    }

    handleScroll(event) {
        this.dispatchAction('auxContentInViewPort', this.isInViewport());
    }

    scrollThrottler(event) {
        // ignore scroll events as long as an listenForFullscreen execution is in the queue
        if ( !this.scrollTimeout ) {
            this.scrollTimeout = setTimeout(function() {
                this.scrollTimeout = null;
                this.handleScroll(event);
            }.bind(this), 50);
        }
    }

    isInViewport() {
        return verge.inViewport(this.element, -10); // cushion of -10px;
    }

    setTitle(title) {
        this.title = title;
    }

    setUrl(url) {
        this.url = url;
    }

    setContent(content) {
        this.content = content;
    }

    hasContent() {
        return !!this.content;
    }

    refreshedElement(){
        this.element.innerHTML = this.content;
        return this.element;
    }
}
